import { render, staticRenderFns } from "./ApplicationApproval.vue?vue&type=template&id=6031bb03&scoped=true&"
import script from "./ApplicationApproval.vue?vue&type=script&lang=js&"
export * from "./ApplicationApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6031bb03",
  null
  
)

export default component.exports